import React from 'react';

const FolderStatusPill = ({ tone = 'success', children }) => {
  return <span className={`folder-pill folder-pill-${tone}`}>{children}</span>;
};

export default FolderStatusPill;
